import axios from './PddCustomAxios';
import { trackPromise } from 'react-promise-tracker';
import { renewAccessTokenIfGoingExpire } from '../../../api/authApi';

/**
 * Check if a PDD project is set as Individual PDD
 * @param {string} projectIdent - The project identifier
 * @returns {Promise} - Response with {isIndividualPDD: boolean}
 */
export const checkIfIndividualPdd = async (projectIdent) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios.get(`/tdd/projects/check-if-individual-pdd/${projectIdent}`, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: tokenHeader,
        },
      })
    );
    
    if (response.data.type === 'error') {
      throw new Error(response.data.message || 'Failed to check individual PDD status');
    }
    
    return response.data;
  } catch (error) {
    console.error('Error checking individual PDD status:', error);
    throw error;
  }
};

/**
 * Mark a PDD project as Individual PDD
 * @param {string} projectIdent - The project identifier
 * @returns {Promise} - Response data
 */
export const markAsIndividualPdd = async (projectIdent) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios.post(`/fullreport/mark-as-individual-pdd/${projectIdent}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: tokenHeader,
        },
      })
    );
    
    if (response.data.type === 'error') {
      throw new Error(response.data.message || 'Failed to mark as individual PDD');
    }
    
    return response.data;
  } catch (error) {
    console.error('Error marking as individual PDD:', error);
    throw error;
  }
};

/**
 * Revert a PDD project from Individual to Standard PDD
 * @param {string} projectIdent - The project identifier
 * @returns {Promise} - Response data
 */
export const revertToStandardPdd = async (projectIdent) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios.post(`/fullreport/revert-to-standard-pdd/${projectIdent}`, {}, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: tokenHeader,
        },
      })
    );
    
    if (response.data.type === 'error') {
      throw new Error(response.data.message || 'Failed to revert to standard PDD');
    }
    
    return response.data;
  } catch (error) {
    console.error('Error reverting to standard PDD:', error);
    throw error;
  }
};
